import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=a918c24a&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"
import style0 from "./Access.vue?vue&type=style&index=0&id=a918c24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a918c24a",
  null
  
)

export default component.exports